import { FC } from 'react';
import { Content, PageSectionHeader } from '@/components';

/** Placeholder: routed and reachable, but not built yet. */
const Reports: FC = () => (
  <>
    <PageSectionHeader>Reports</PageSectionHeader>
    <Content>
      <p>This page has not been built yet.</p>
    </Content>
  </>
);

export default Reports;
